import React, { FC, useState,useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Checkbox, FormControlLabel, Box } from '@mui/material';
import { getWarehouseCompanyMapping,userWarehouseMapping,getWarehouseMapping,deleteWarehouseUserMapping} from './action.ts';
import Heading from '../../Components/Heading/heading.tsx';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
interface Warehouse {
    id: string;
    name: string;
}

interface WarehousesModalProps {
    open: boolean;
    onClose: () => void;
    userId:any;
    source: 'addUserModal' | 'userPage';

}

const WarehousesModal: FC<WarehousesModalProps> = ({ open, onClose,userId,source}) => {
    const [selectedWarehouses, setSelectedWarehouses] = useState<string[]>([]);
    const [warehouses, setWarehouses] = useState<any[]>([]);
    const [initialMappings, setInitialMappings] = useState<any[]>([]); 

    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const companiesId =  userDetailsFromStorage?.companies_id || '';

    useEffect(() => {
        if(open){
            getWarehouseCompanyMapping(
                companiesId,
                (response) => {
                    if (response.status === 200) {
                        setWarehouses(response.user_warehouses);
                    } else {
                        toast.error("Failed to fetch warehouses");
                    }
                },
                (errorMessage) => {
                    toast.error(errorMessage.message);
                }
            );

            if (source === 'userPage' && userId) {
                getWarehouseMapping(userId, 0, "100",
                    (response) => {
                        if (response.status === 200) {
                            const mappedWarehouseIds = response.user_warehouses.map((mapping: any) => mapping.warehouse.id);
                            setSelectedWarehouses(mappedWarehouseIds);
                            setInitialMappings(response.user_warehouses);
                        } else {
                            toast.error("Failed to fetch warehouses");
                        }
                    },
                    (errorMessage) => {
                        toast.error(errorMessage);
                    });
            } else {
                setSelectedWarehouses([]);
                setInitialMappings([]);
            }
        }
    }, [open, userId, source, companiesId]);

    const handleCheckboxChange = (warehouseId: string) => {
        setSelectedWarehouses((prevSelected) => {
            const isCurrentlySelected = prevSelected.includes(warehouseId);
            if (isCurrentlySelected) {
                return prevSelected.filter((id) => id !== warehouseId);
            } else {
                return [...prevSelected, warehouseId];
            }
        });
    };

    const handleSubmit = () => {
        if (selectedWarehouses.length === 0) {
            toast.error("Please select at least one warehouse.");
            return;
        }

        const warehousesToAdd = selectedWarehouses.filter(whId => 
            !initialMappings.some(mapping => mapping.warehouse.id === whId)
        );

        const warehousesToRemove = initialMappings
            .filter(mapping => !selectedWarehouses.includes(mapping.warehouse.id))
            .map(mapping => mapping.id); 

        warehousesToRemove.forEach(mappingId => {
            deleteWarehouseUserMapping(
                mappingId,
                (response) => {
                    console.log(`Warehouse mapping ${mappingId} deleted successfully!`);
                },
                (errorMessage) => {
                    toast.error(`Failed to unmap warehouse: ${errorMessage}`);
                }
            );
        });

        warehousesToAdd.forEach(warehouseId => {
            userWarehouseMapping(
                userId,
                warehouseId,
                (response) => {
                    toast.success(`Warehouse mapped successfully!`);
                },
                (errorMessage) => {
                    toast.error(`Failed to map warehouse: ${errorMessage}`);
                }
            );
        });

        if (warehousesToAdd.length > 0 || warehousesToRemove.length > 0) {
            toast.success("Warehouse mappings updated successfully!");
        }

        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle sx={{ padding: '0px' }}>
                <Box sx={{ marginLeft: { xs: '0px', sm: '-180px' } }}>
                    <Heading title="Warehouses" closeIcon="true" onClose={onClose} />
                </Box>
            </DialogTitle>
            <DialogContent>
                {warehouses.map((mapping) => (
                    <FormControlLabel
                        key={mapping.warehouse.id}
                        control={
                            <Checkbox
                                checked={selectedWarehouses.includes(mapping.warehouse.id)}
                                onChange={() => handleCheckboxChange(mapping.warehouse.id)}
                            />
                        }
                        label={mapping.warehouse.name}
                    />
                ))}
            </DialogContent>
            <DialogActions style={{ justifyContent: 'center' }}>
                <Button
                    onClick={onClose}
                    className="custom-cancel-button"
                    style={{ marginRight: '10px' }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleSubmit}
                    className="custom-button"
                    style={{ marginLeft: '10px' }}
                >
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default WarehousesModal;